import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const FbwA380xChecklistMarketingSeo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="The Super, simplified">
        <Text fz="medium">
          The FlyByWire A380X is an ambitious open-source recreation of the world's largest
          passenger aircraft. Four engines, a double-deck cabin, and a glass cockpit packed with
          state of the art avionics — there's a lot to manage on the flight deck.{" "}
          <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Four engines, one checklist">
        <Text fz="medium">
          This checklist is adapted from{" "}
          <a
            href="https://www.youtube.com/@jaydeegaming"
            target="_blank"
            data-goatcounter-click="jaydee-youtube-link"
          >
            JayDee
          </a>
          's A380 checklist on{" "}
          <a
            href="https://msfschecklist.de"
            target="_blank"
            data-goatcounter-click="msfschecklist-link"
          >
            msfschecklist.de
          </a>
          , covering every phase from cockpit preparation through securing the aircraft. Tailor it
          to your style in{" "}
          <Text span c="black" fw="bold">
            fs-checklist-studio
          </Text>{" "}
          — add flows for your favorite addons, highlight memory items, and export a PDF for your
          kneeboard.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
